import { RELATED_PERSON_RELATIONSHIPS } from "@repo/domain";
import { z } from "zod";
import { newEntityIdSchema } from "./entity-id.schemas";

export const relatedPersonDetails = {
  name: z
    .object({ given: z.array(z.string().trim().min(1)), family: z.string().trim().min(1).optional() })
    .refine((value) => value.given.length > 0 || !!value.family, "A name is required"),
  relationships: z.array(z.enum(RELATED_PERSON_RELATIONSHIPS)).min(1),
  email: z.string().trim().email(),
  phone: z.string().trim().min(1).optional(),
};

export const registrationRelatedPersonSchema = z
  .object({
    id: newEntityIdSchema,
    ...relatedPersonDetails,
    isEmergencyContact: z.boolean().default(false),
    portalAccess: z.boolean().default(false),
  })
  .strict();
